'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _launcherOpenIconDark = require('bender-url!../../../img/visitor-widget/launcher-open-icon-dark.svg');

Object.defineProperty(exports, 'launcherOpenDark', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_launcherOpenIconDark).default;
  }
});

var _launcherOpenIcon = require('bender-url!../../../img/visitor-widget/launcher-open-icon.svg');

Object.defineProperty(exports, 'launcherOpen', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_launcherOpenIcon).default;
  }
});

var _launcherCloseIcon = require('bender-url!../../../img/visitor-widget/launcher-close-icon.svg');

Object.defineProperty(exports, 'launcherClosed', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_launcherCloseIcon).default;
  }
});

var _launcherCloseIconDark = require('bender-url!../../../img/visitor-widget/launcher-close-icon-dark.svg');

Object.defineProperty(exports, 'launcherClosedDark', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_launcherCloseIconDark).default;
  }
});

var _initialMessageBubbleTail = require('bender-url!../../../img/visitor-widget/initialMessageBubbleTail.svg');

Object.defineProperty(exports, 'initialMessageBubbleTail', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_initialMessageBubbleTail).default;
  }
});

var _botAvatar = require('bender-url!../../../img/visitor-widget/bot-avatar.svg');

Object.defineProperty(exports, 'mrHubBot', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_botAvatar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }